export const SETTINGS_DIALOG_MODE = {
  detail: 'DETAIL',
  edit: 'EDIT',
  create: 'CREATE',
}
